import { SuiThemeProvider } from '@hrworks/design-system/components';
import { LocalizationProvider } from '@hrworks/localization';

import { ToastProvider } from '../Toast';
import type { SuiProviderProps } from './SuiProvider.types';

export const SuiProvider = ({ children, dictionary, locale, ...otherProps }: SuiProviderProps) => (
  <SuiThemeProvider {...otherProps}>
    <LocalizationProvider dictionary={dictionary} locale={locale}>
      <ToastProvider>{children}</ToastProvider>
    </LocalizationProvider>
  </SuiThemeProvider>
);
